import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LessonSchedule} from 'src/app/classes/LessonSchedule';
import {Room} from 'src/app/classes/Room';
import { User } from 'src/app/classes/User';
import { getRoomColorHex, getRoomColorTextHex } from 'src/app/util/room-color.util';

@Component({
    selector: 'app-lessons-schedule-edit',
    styleUrls: ['./lessons-schedule-edit.component.scss'],
    templateUrl: './lessons-schedule-edit.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LessonsScheduleEditComponent implements OnInit {

    lessonSchedule: LessonSchedule;
    teachers: User[];
    teacherId: number;
    rooms: Room[];

    days: string[] = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];

    destroy = new Subject<any>();
    currentDialog = null;
    errorMessage: string;

    public lessonScheduleGroup: FormGroup;

    constructor(private activeModal: NgbActiveModal,
                private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        if (this.lessonSchedule) {
            this.lessonScheduleGroup = this.formBuilder.group({
                id: [this.lessonSchedule.id],
                name: [this.lessonSchedule.name],
                nameHebrew: [this.lessonSchedule.nameHebrew],
                isOnline: [this.lessonSchedule.isOnline],
                maxStudents: [this.lessonSchedule.maxStudents],
                minAge: [this.lessonSchedule.minAge],
                maxAge: [this.lessonSchedule.maxAge],
                startDate: [this.lessonSchedule.startDate],
                endDate: [this.lessonSchedule.endDate],
                startTime: [this.lessonSchedule.startTime],
                endTime: [this.lessonSchedule.endTime],
                dayOfWeek: [this.lessonSchedule.dayOfWeek],
                teacherId: [this.teacherId],
                roomId: [this.lessonSchedule.roomId],
            });
        } else {
            this.lessonScheduleGroup = this.formBuilder.group({
                id: [null],
                name: [null, Validators.required],
                nameHebrew: [null, Validators.required],
                isOnline: [true, Validators.required],
                maxStudents: [100, Validators.required],
                minAge: [null, Validators.required],
                maxAge: [null, Validators.required],
                startDate: [(new Date()).toISOString().split('T')[0], Validators.required],
                endDate: [null, Validators.required],
                startTime: ["10:00", Validators.required],
                endTime: ["11:00", Validators.required],
                dayOfWeek: ["MONDAY", Validators.required],
                teacherId: [this.teacherId, Validators.required],
                roomId: [null],
            });
        }
    }

    closeModal(sendData): void {
        this.activeModal.close(sendData);
    }

    getRoomOptionStyle(room: Room): Record<string, string> {
        return {
            'background-color': getRoomColorHex(room?.color),
            color: getRoomColorTextHex(room?.color)
        };
    }

    getSelectedRoomStyle(): Record<string, string> {
        const selectedRoomId = Number(this.lessonScheduleGroup?.get('roomId')?.value);
        const selectedRoom = this.rooms?.find((room) => room.id === selectedRoomId);
        return this.getRoomOptionStyle(selectedRoom);
    }
}
